import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { combineAll, DcBaseComponent } from '@datachain/ui-sdk/common';
import {
	AppModalService,
	ModalData,
} from '@datachain/ui-sdk/components/app-modal';
import { Observable } from 'rxjs';

import { DcIcons } from '../../../../ui/app-dc.icons';

export enum ColumnModelAction {
	Update = 'update',
	Delete = 'delete',
}

export interface IColumnModelConfirmationModalData {
	columnModelId: string | Array<string>;
	element: string;
	action: ColumnModelAction;
}

@Component({
	selector: 'app-column-model-action-confirm-popup',
	templateUrl: './column-model-action-confirm-popup.component.html',
	styleUrls: ['./column-model-action-confirm-popup.component.scss'],
})
export class ColumnModelActionConfirmPopupComponent<
	T extends IColumnModelConfirmationModalData
> extends DcBaseComponent {
	protected readonly ColumnModelAction = ColumnModelAction;
	protected readonly DcIcons = DcIcons;

	public vo$: Observable<{
		element: string;
		columnModelId: string | Array<string>;
		action: ColumnModelAction;
		isMultipleElement: boolean;
	}>;

	public confirm = false;

	public constructor(
		private readonly modalService: AppModalService,
		@Inject(MAT_DIALOG_DATA) public readonly modalData: ModalData & T
	) {
		super();
		this.cmpId = 'column-model-action-confirm-popup';

		this.vo$ = combineAll({
			element: this.modalData.element,
			isMultipleElement: Array.isArray(this.modalData.columnModelId),
			columnModelId: this.modalData.columnModelId,
			action: this.modalData.action,
		});
	}

	public launchAction(): void {
		this.modalService.closeActiveModal({
			shouldLaunch: true,
		});
	}
}
